export const referralColorMap = {
  active: "#096F45",
  needs_help: "#9E1414",
  incomplete: "#B55700",
  pending: "#460D90",
  unenrolled: "#7A7A83",
  demo: "#1448CB",
  "Setup Pending": "#460D90",
  Active: "#096F45",
  Expired: "#9E1414",
  failed: "#9E1414",
  inactive: "#9E1414",
  Unverified: "#B55700",
  Verified: "#460D90",
  Invited: "#460D90",
  Unenrolled: "#7A7A83"
}

export const referralTagBgColorMap = {
  active: "#E7FFF1",
  needs_help: "#FFF4F4",
  incomplete: "#FFF5EA",
  pending: "#F6F0FF",
  unenrolled: "#F4F4F5",
  demo: "#F2F6FF",
  "Setup Pending": "#F6F0FF",
  Active: "#E7FFF1",
  Expired: "#FFF4F4",
  failed: "#FFF4F4",
  inactive: "#FFF4F4",
  Unverified: "#FFF5EA",
  Verified: "#F6F0FF",
  Invited: "#F6F0FF",
  Unenrolled: "#F4F4F5"
}

export const referralTextMap = {
  active: "Active",
  needs_help: "Needs help",
  incomplete: "Incomplete",
  pending: "Pending",
  unenrolled: "Unenrolled",
  demo: "Demo",
  "Setup Pending": "Setup Pending",
  Active: "Active",
  Expired: "Expired",
  failed: "Failed",
  inactive: "Inactive",
  Unverified: "Unverified",
  Verified: "Verified",
  Invited: "Invited",
  Unenrolled: "Unenrolled"
}

export const referralStatusTooltip = {
  incomplete: "The BA is still in the onboarding process.",
  demo: "The BA is in demo mode and the balance hasn’t been topped up yet.",
  needs_help: "There are issues with the ARN code or descriptors that require attention.",
  pending: "Awaiting an admin action for further progress.",
  active: "The user has full access to the platform.",
  inactive: "The user can access the platform but doesn’t receive alerts.",
  unenrolled: "The BA has been unenrolled from the platform.",
  failed: "All descriptors for enrollment failed for this BA."
}
